/**
 *
 * @author: Matthew Rawson @ 16/05/2018 14:35
 * @description:
 * @notes:
 */
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {OverlayTrigger, Tooltip} from "react-bootstrap"
import {round, isNaN} from "lodash"

import id from "@irati/utils/id"
import {perkbox} from "@irati/ui/src/global/colors"
import {H4} from "@irati/ui/src/Headings"
import {Label3} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"

export const DEFAULT_HEIGHT = 30


const Bar = styled.div`
  display: inline-block;
  width: 100%;
  background-color: ${perkbox.blue};
`


const AnswerBar = ({count, yScaleMax, total, ...props}) => {
  const idNamespace = id("AnswerBar", props)

  /** Percentage of total responses */
  let percOfTotal = count / total
  percOfTotal = round((isNaN(percOfTotal) || percOfTotal === Infinity ? 0 : percOfTotal) * 100, 1)

  /** Determine the count percentage of yScaleMax */
  let heightPercentage = count / yScaleMax
  heightPercentage = isNaN(heightPercentage) || heightPercentage === Infinity ? 0 : heightPercentage

  /** If zero, show 5% of the default height. It looks weird having empty space for the bar */
  heightPercentage = heightPercentage === 0 ? 0.05 : heightPercentage

  /** Assign to the css */
  const barStyles = {height: `${heightPercentage * DEFAULT_HEIGHT}px`}

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={(
        <Tooltip id={id("tooltip", idNamespace)}>
          <H4>{percOfTotal}%</H4>
          <Label3><FormattedMessage id="insights.analysis.questions.answerBar.responseCount" values={{count}} /></Label3>
        </Tooltip>
      )}>
      <Bar id={idNamespace} style={barStyles} />
    </OverlayTrigger>
  )
}


AnswerBar.propTypes = {
  total: PropTypes.number,
  count: PropTypes.number,
  yScaleMax: PropTypes.number
}
AnswerBar.defaultProps = {
  total: 0,
  count: 0,
  yScaleMax: 0
}

export default AnswerBar
